import {OnboardingContainer} from '@/components/PageContainer/OnboardingContainer';
import {Outlet} from 'react-router-dom';

export const OnboardingLayout = () => {
  return (
    <OnboardingContainer>
      <Outlet />
    </OnboardingContainer>
  );
};
